import { render, staticRenderFns } from "./BillCard.vue?vue&type=template&id=5fcd46e4&scoped=true&"
import script from "./BillCard.vue?vue&type=script&lang=js&"
export * from "./BillCard.vue?vue&type=script&lang=js&"
import style0 from "./BillCard.vue?vue&type=style&index=0&id=5fcd46e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd46e4",
  null
  
)

export default component.exports